module.exports = __webpack_public_path__ + "img/宁波市.fd8c53ed.png";